// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, logEvent } from "firebase/analytics";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB_jRRUouPuVvRhGwkpg-OIpA3nI0Kc7wU",
  authDomain: "it-tbh.firebaseapp.com",
  projectId: "it-tbh",
  storageBucket: "it-tbh.firebasestorage.app",
  messagingSenderId: "680702513702",
  appId: "1:680702513702:web:b795dc84ec1a36d6fc0ce7",
  measurementId: "G-Z0H7EJDWNS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Analytics must not prevent rendering or form submission in browsers where
// storage is unavailable or a privacy extension blocks the provider.
let analytics = null;
isSupported()
  .then((supported) => {
    if (supported) analytics = getAnalytics(app);
  })
  .catch(() => {});

// Helper function to log events
const logAnalyticsEvent = (eventName, eventParams = {}) => {
  if (analytics) {
    try {
      logEvent(analytics, eventName, eventParams);
    } catch {
      // Telemetry is optional; the visitor's action must still complete.
    }
  }
};

export { app, analytics, logAnalyticsEvent };
